module.exports = __webpack_public_path__ + "img/food thorough.d3a7e5cd.png";